import { h } from 'preact';

import { withShowtimesBehavior } from 'components/editor/movies/showtimes/showtimes';
import UniversalWatchPageEditor from 'components/editor/movies/watch/watchUniversal';

import s from 'components/editor/movies/showtimes/showtimesUniversal.sss';

export default class UniversalShowtimesEditor extends withShowtimesBehavior(UniversalWatchPageEditor) {
	s = s; // Styling will only be assigned in the final implementation (i.e. showtimesUniversal.js)
}